/**
 * Fab Works visual tokens — industrial steel and navy, shared by the whole app.
 * Originally proven in the Outside Sales Portal (components/sales/salesUi.js).
 */
export const FW = {
  navy: '#0B1F33',
  navyMid: '#143049',
  steel: '#1B6CA8',
  steelDark: '#155A8F',
  steelSoft: '#E8F2FA',
  accent: '#B26A00',
  accentSoft: '#FFF4DE',
  ink: '#1A2332',
  muted: '#5B6B7C',
  line: '#D9E2EC',
  surface: '#F3F6F9',
  subtle: '#F7F9FB',
  white: '#FFFFFF',
  success: '#1F7A4D',
  successSoft: '#E6F5EE',
  warning: '#A66A00',
  warningSoft: '#FFF4DE',
  danger: '#B42318',
  dangerSoft: '#FEECEC',
  info: '#175CD3',
  infoSoft: '#EAF2FF',
  neutralSoft: '#EEF2F6',
};

export const FW_SHADOW = {
  card: '0 1px 2px rgba(16, 32, 48, 0.06)',
  raised: '0 4px 14px rgba(16, 32, 48, 0.10)',
};

/** Langley Construction Services — black, white, and warm grays. */
export const LS = {
  black: '#141414',
  blackSoft: '#232323',
  white: '#ffffff',
  gray: '#6b6560',
  grayLight: '#f7f6f4',
  orange: '#141414',
  orangeDark: '#141414',
  orangeSoft: '#f0eeea',
  accent: '#141414',
  accentSoft: '#f0eeea',
  ink: '#141414',
  muted: '#6b6560',
  line: '#e5e2dd',
  surface: '#f7f6f4',
  subtle: '#f0eeea',
  success: '#1F7A4D',
  successSoft: '#E6F5EE',
  warning: '#8a8178',
  warningSoft: '#f0eeea',
  danger: '#B42318',
  dangerSoft: '#FEECEC',
  info: '#175CD3',
  infoSoft: '#EAF2FF',
  neutralSoft: '#EEF2F6',
};

export const LS_SHADOW = {
  card: '0 1px 2px rgba(10, 10, 10, 0.06)',
  raised: '0 4px 14px rgba(10, 10, 10, 0.10)',
};

/** WHW Industrial Solutions — charcoal and deep red from the brand mark. */
export const WHW = {
  black: '#141414',
  blackSoft: '#232323',
  red: '#8B0000',
  redDark: '#6E0000',
  redSoft: '#F8EAEA',
  white: '#ffffff',
  gray: '#6b6560',
  grayLight: '#f7f6f4',
  accent: '#8B0000',
  accentSoft: '#F8EAEA',
  ink: '#141414',
  muted: '#6b6560',
  line: '#e5e2dd',
  surface: '#f7f6f4',
  subtle: '#f0eeea',
  success: '#1F7A4D',
  successSoft: '#E6F5EE',
  warning: '#8a8178',
  warningSoft: '#f0eeea',
  danger: '#B42318',
  dangerSoft: '#FEECEC',
  info: '#175CD3',
  infoSoft: '#EAF2FF',
  neutralSoft: '#EEF2F6',
};

export const WHW_SHADOW = {
  card: '0 1px 2px rgba(10, 10, 10, 0.06)',
  raised: '0 4px 14px rgba(10, 10, 10, 0.10)',
};
